import type { Page } from "src/api/interfaces/page";
import type { Realm } from "src/api/interfaces/realm";

interface CountryConfig {
  pages: Page[];
  realm: Realm;
}
export const countryConfigMap = new Map<string, CountryConfig>()
  // EU Country Codes
  .set("EG", { realm: "EU", pages: ["AIC"] })
  .set("FR", { realm: "EU", pages: ["NEST"] })
  .set("PL", { realm: "EU", pages: [] })
  .set("TR", { realm: "EU", pages: ["AIC"] })
  .set("RO", { realm: "EU", pages: ["AIC"] })
  .set("MY", { realm: "EU", pages: ["AIC"] })
  .set("BE", { realm: "EU", pages: [] })
  .set("RS", { realm: "EU", pages: ["AIC"] })
  .set("GR", { realm: "EU", pages: ["AIC"] })
  .set("AE", { realm: "EU", pages: ["AIC", "NEST"] })
  .set("DE", { realm: "EU", pages: ["NEST"] })
  // NA Country Codes
  .set("BR", { realm: "NA", pages: ["AIC"] })
  .set("CL", { realm: "NA", pages: ["AIC"] })
  .set("MX", { realm: "NA", pages: ["AIC"] });
